var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NewBusiness',{key:_vm.keyyy,attrs:{"information_details":_vm.data,"for_update":true},on:{"on_update_data":_vm.on_update_data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }